import { SET_CLEAR_VALUE } from 'redux/modules/page/actions/types';

export default function setClearValue(isValueClear: boolean) {
  return { type: SET_CLEAR_VALUE, isValueClear };
}
